module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "App"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.useLegacy === false) ? _c('div', {
    attrs: {
      "id": "NewGanttLab"
    }
  }, [_c('div', [_c('h1', [_vm._v("GanttLab got better!")]), _vm._v(" "), _c('p', [_c('iframe', {
    attrs: {
      "id": "ytplayer",
      "type": "text/html",
      "width": "400",
      "height": "225",
      "src": "https://www.youtube.com/embed/mk0OseE61H0",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tweet"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/GanttLab",
      "target": "_blank"
    }
  }, [_vm._v("Latest announcements "), _c('i', {
    staticClass: "fa fa-twitter"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "links"
  }, [_c('a', {
    staticClass: "stick",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.useLegacy = true
      }
    }
  }, [_vm._v("Stick to Legacy")]), _c('a', {
    staticClass: "rediscover",
    attrs: {
      "href": "https://app.ganttlab.org/"
    }
  }, [_vm._v("Rediscover GanttLab  >")])])])]) : _vm._e(), _vm._v(" "), (_vm.useLegacy && (_vm.loginFailed || !_vm.userName)) ? _c('div', {
    attrs: {
      "id": "LoginScreen"
    }
  }, [_c('h1', [_vm._v("GanttLab Live"), _c('span', {
    staticClass: "timezone"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" " + _vm._s(_vm.timezone))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col welcome"
  }, [_c('div', {
    staticClass: "pad"
  }, [_c('h2', [_vm._v("The easy to use, fully functional\n            "), _c('br'), _vm._v("Gantt chart for GitLab and GitHub.")]), _vm._v(" "), _c('p', [_vm._v("Provide your teams with the right tool to master time and deadlines. Giving back credit to your project status and issues due dates has never been easier!")]), _vm._v(" "), (!_vm.userName && _vm.downloading) ? _c('p', {
    staticClass: "downloading"
  }, [_c('strong', [(_vm.downloading) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" Connecting to " + _vm._s(_vm.url))])]) : _vm._e(), _vm._v(" "), (_vm.loginFailed) ? _c('p', {
    staticClass: "error"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" Unable to connect to " + _vm._s(_vm.url))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col form"
  }, [_c('p', {
    staticClass: "providerchoice"
  }, [_c('i', {
    staticClass: "fa fa-gitlab",
    class: {
      selected: _vm.isGitLab
    },
    on: {
      "click": function($event) {
        _vm.providerName = 'GitLab'
      }
    }
  }), _c('span', [_vm._v(" or ")]), _c('i', {
    staticClass: "fa fa-github",
    class: {
      selected: !_vm.isGitLab
    },
    on: {
      "click": function($event) {
        _vm.providerName = 'GitHub'
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "form-input first"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.url),
      expression: "url"
    }],
    class: {
      disabled: _vm.providerName != 'GitLab'
    },
    attrs: {
      "tabindex": "1",
      "disabled": _vm.providerName != 'GitLab',
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.url)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.signin($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.url = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "helper",
    class: {
      disabled: _vm.providerName != 'GitLab'
    }
  }, [_vm._v("Your GitLab instance URL")]), _vm._v(" "), _c('p', {
    staticClass: "form-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.token),
      expression: "token"
    }],
    attrs: {
      "tabindex": "2"
    },
    domProps: {
      "value": (_vm.token)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.signin($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.token = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.providerName == 'GitLab') ? _c('p', {
    staticClass: "helper"
  }, [_vm._v("Use your "), _c('a', {
    attrs: {
      "href": _vm.privateTokenLink,
      "target": "_blank",
      "title": "/profile/account"
    }
  }, [_vm._v("Private Token")]), _vm._v(", or a "), _c('a', {
    attrs: {
      "href": _vm.personalTokenLink,
      "target": "_blank",
      "title": "/profile/personal_access_tokens"
    }
  }, [_vm._v("Personal Access Token")])]) : _c('p', {
    staticClass: "helper"
  }, [_vm._v("Use one of your "), _c('a', {
    attrs: {
      "href": "https://github.com/settings/tokens",
      "target": "_blank",
      "title": "https://github.com/settings/tokens"
    }
  }, [_vm._v("Personal Access Tokens")])]), _vm._v(" "), (_vm.hasLocalStorage) ? _c('p', {
    staticClass: "form-input remember"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rememberMe),
      expression: "rememberMe"
    }],
    attrs: {
      "tabindex": "3",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.rememberMe) ? _vm._i(_vm.rememberMe, null) > -1 : (_vm.rememberMe)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.rememberMe,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.rememberMe = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.rememberMe = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rememberMe = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Remember me "), _c('i', {
    staticClass: "fa fa-question-circle-o",
    attrs: {
      "aria-hidden": "true",
      "title": "Don't do that on a public computer!"
    }
  })]), _vm._v(" "), _c('button', {
    attrs: {
      "tabindex": "4"
    },
    on: {
      "click": _vm.signin
    }
  }, [_vm._v("Sign-in  >")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "more"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col copy"
  }, [_c('div', {
    staticClass: "pad"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "https://www.ganttlab.org",
      "target": "_blank"
    }
  }, [_vm._v("Read more about GanttLab"), _c('i', {
    staticClass: "fa fa-external-link"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("© 2016-2020 "), _c('a', {
    attrs: {
      "href": "http://clorichel.com/",
      "target": "_blank"
    }
  }, [_vm._v("Pierre-Alexandre Clorichel")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col social"
  }, [_c('div', {
    staticClass: "pad"
  }, [_c('p', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/GanttLab",
      "target": "_blank"
    }
  }, [_vm._v("Twitter")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/GanttLab-324440334610008/",
      "target": "_blank"
    }
  }, [_vm._v("Facebook")])])])])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.useLegacy && _vm.userName) ? _c('div', {
    attrs: {
      "id": "MainScreen"
    }
  }, [_c('div', {
    staticClass: "standardpadding",
    attrs: {
      "id": "top"
    }
  }, [(_vm.userName) ? _c('div', [_c('span', {
    staticClass: "user"
  }, [_c('img', {
    attrs: {
      "src": _vm.userAvatarUrl
    }
  }), _vm._v(" " + _vm._s(_vm.userName))]), _vm._v(" "), _c('span', {
    staticClass: "server"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.downloading) ? _c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin downloading",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.url,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.url))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://gitlab.com/ganttlab/ganttlab-live#how-it-works",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true",
      "title": "Help"
    }
  })]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-times close",
    attrs: {
      "aria-hidden": "true",
      "title": "Close"
    },
    on: {
      "click": _vm.logout
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c(_vm.provider, {
    tag: "component",
    staticClass: "provider"
  }), _vm._v(" "), _c('div', {
    staticClass: "standardpadding"
  }, [(_vm.downloading) ? _c('p', {
    staticClass: "downloading"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.tasks != null) ? _c('gantt') : _vm._e()], 1), _vm._v(" "), (!_vm.downloading && (this.paginationLinks.prev || this.paginationLinks.next)) ? _c('div', {
    staticClass: "pagination"
  }, [(this.paginationLinks.prev) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.paginationPage--
      }
    }
  }, [_vm._v("< Prev")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Page " + _vm._s(this.paginationPage))]), _vm._v(" "), (this.paginationLinks.next) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.paginationPage++
      }
    }
  }, [_vm._v("Next >")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "perpage"
  }, [_vm._v("\n          Showing\n          "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paginationPerPage),
      expression: "paginationPerPage"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.paginationPerPage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l(([10, 20, 50, 75, 100]), function(value) {
    return _c('option', {
      domProps: {
        "value": value
      }
    }, [_vm._v(_vm._s(value))])
  }), 0), _vm._v("\n          issues per page\n        ")])]) : _vm._e()], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-af08ba8c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 164
// module chunks = 2